import apiClient from '../lib/axios';

export interface BranchStock {
  name: string;
  quantity: number;
}

export interface PharmacyProductResult {
  id: string;
  name: string;
  chainName: string;
  price: string;
  branches: BranchStock[];
  totalQuantity: number;
  isControlled: boolean;
  isRecommended: boolean;
}

export interface PharmacyProductSearchResponse {
  results: PharmacyProductResult[];
  total: number;
}

export async function searchPharmacyProducts(
  q: string,
  limit = 20,
): Promise<PharmacyProductSearchResponse> {
  const { data } = await apiClient.get<PharmacyProductSearchResponse>(
    '/pharmacy-products/search',
    { params: { q, limit } },
  );
  return data;
}
